import 'whatwg-fetch';
import Promise from 'promise-polyfill';
import { getAuthToken, getUserAccessToken } from './lib/auth-token';

// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}

let lang = 'en-US';

export const setLanguage = (language) => {
  lang = language;
};

const FetchApi = (
  url = '',
  options = {},
  isWithCredentials = false,
  type = 'get',
  reqData = {},
  isSkipAcceptLangHeader = false,
  includeUserAccessToken = false,
) => {
  const defaultOptions = {
    method: type || 'get',
    headers: {
      ...getAuthToken(),
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  };

  if (includeUserAccessToken) {
    defaultOptions.headers['user-access-token'] = getUserAccessToken();
  }

  if (!isSkipAcceptLangHeader) {
    defaultOptions.headers['Accept-Language'] =
      `${lang.replace('_', '-')};q=0.8`;
  }
  if (type === 'post') {
    defaultOptions.body = JSON.stringify(reqData);
  }

  if (url.indexOf('/ui/commonheader') !== -1) {
    defaultOptions.headers.isCommonUI = true;
  }
  // since Object.assign doesn't do deep merge we need to do it ourselfs
  const finalHeaders = { ...defaultOptions.headers, ...options.headers };
  let finalOptions = { ...defaultOptions, ...options, headers: finalHeaders };
  if (isWithCredentials) {
    finalOptions = { ...defaultOptions, ...options, headers: {} };
  }
  return fetch(url, finalOptions).then((res) => {
    if (res.ok) {
      const responseHeaders = res.headers;
      if (
        responseHeaders.get('Content-Type').indexOf('application/json') !==
          -1 &&
        !includeUserAccessToken
      ) {
        return res.json();
      }
      return res.text();
    }
    return Promise.reject(res);
  });
};

export default FetchApi;
